import { makeStyles } from '@material-ui/core';
import oneLoopAiLogo from '../../assets/oneloopai-logo.svg';

const useStyles = makeStyles({
  svg: {
    height: 40,
    width: 'auto',
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <img className={classes.svg} src={oneLoopAiLogo} alt="HTEC OneLoopAi" />
  );
};

export default LogoFull;
